<template>
    <div class="Mypage">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>내정보</h2>
            <div class="btn_back">
                <a @click="slidePanelClose"><img src="@/assets/images/btn_close.png" width="50" alt="이전" /></a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <h2 class="slidePanel-title">
                <!-- s: profile-area -->
                <div class="profile-area">
                    <div class="image-area"
                         :style="'background-image: url('+userProfileImg+')'">
                        <a class="btn-profile-edit ir">사진편집</a>
                    </div>
                    <div class="nickname-area">
                        <h5>별명</h5>
                        <h3>{{ userProfileName }}<span>님</span></h3>
                        <span>{{ userProfileId }}</span>
                    </div>
                </div>
                <!-- e: profile-area -->
            </h2>
            <div>
                <ul class="li-bottom-line">
                    <li @click="profileSlideView">
                        <a>프로필 수정</a>
                        <i class="arrow"></i>
                    </li>
                    <li @click="memberSlideView">
                        <a>회원정보</a>
                        <i class="arrow"></i>
                    </li>
                    <li @click="gleSlideView">
                        <a>그레내역</a>
                        <i class="arrow"></i>
                    </li>
                    <li @click="payMentSlideView">
                        <a>결제내역</a>
                        <i class="arrow"></i>
                    </li>
                    <li @click="myBoardSlideView">
                        <a>내 게시물 보기</a>
                        <i class="arrow"></i>
                    </li>
                </ul>
            </div>
            <!-- 알림설정 -->
            <div class="mrg-top-20">
                <h3 class="slidePanel-sub-title">알림설정</h3>
                <ul class="li-bottom-line no-bottom">
                    <li>
                        <a>댓글 알림</a>
                        <mt-switch v-model="bReplyAlarmYn"
                                   @change="setPushChangeFunc">
                        </mt-switch>
                    </li>
                    <li>
                        <a>공지 알림</a>
                        <mt-switch v-model="bNoticeAlarmYn"
                                   @change="setPushChangeFunc">
                        </mt-switch>
                    </li>
                    <li>
                        <a>쪽지 알림</a>
                        <mt-switch v-model="bMessageAlarmYn"
                                   @change="setPushChangeFunc">
                        </mt-switch>
                    </li>
                </ul>
            </div>
        </div>
        <!-- e: contents -->
    </div>
</template>
<script>
export default {
    name: 'Mypage',
    data() {
        return {
            userProfileImg:'',      // 사용자 이미지
            userProfileName:'',     // 사용자 이름
            userProfileId:'',       // 사용자 아이디
            bReplyAlarmYn:false,    // 댓글알림
            bNoticeAlarmYn:false,   // 공지알림
            bMessageAlarmYn:false,  // 쪽지알림
        }
    },
    // 감시자
    watch: {
    },
    // $el 생성전
    created(){
        this.gnbProfileFunc();
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        this.getPushInfoFunc();
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 프로필
        gnbProfileFunc(){
            let param = {};
            this.ajaxGetAuth('/api/v1/gnb/profile', param,this.gnbProfileFuncResult);
        },
        // 프로필 결과
        gnbProfileFuncResult(response){
            let result = response.result;
            if (result.code == 0){
                this.userProfileImg = response.oProfile.oUser.profileImg;
                this.userProfileName = response.oProfile.oUser.strNickName;
                this.userProfileId = response.oProfile.oUser.strUserId;
            }else{
                this.toastMsg(result.resultNoti.message);
            }
        },
        // 프로필수정 Slide
        profileSlideView(){
            // this.slidePanelClose();
            const panel =this.$showPanel({
                component: () => import('@/views/slide/Profile'),
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                window.callbackBackKey = this.callbackBackKey;
                if (result == "close"){
                    this.slidePanelClose(result);
                }
            });
        },
        // 회원정보 Slide
        memberSlideView(){
            // this.slidePanelClose();
            const panel =this.$showPanel({
                component: () => import('@/views/slide/Member'),
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                window.callbackBackKey = this.callbackBackKey;
                if (result.result === "close"){
                    this.slidePanelClose(result);
                }
            });
        },
        // 그레내역 Slide
        gleSlideView(){
            // this.slidePanelClose();
            const panel =this.$showPanel({
                component: () => import('@/views/slide/Gre'),
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                window.callbackBackKey = this.callbackBackKey;
                if (result.result === "close"){
                    this.slidePanelClose(result);
                }
            });
        },
        // 결제내역 Slide
        payMentSlideView(){
            // this.slidePanelClose();
            const panel =this.$showPanel({
                component: () => import('@/views/slide/Payment'),
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                window.callbackBackKey = this.callbackBackKey;
                if (result.result === "close"){
                    this.slidePanelClose(result);
                }
            });
        },
        // 내게시물보기 Slide
        myBoardSlideView(){
            // this.slidePanelClose();
            const panel =this.$showPanel({
                component: () => import('@/views/slide/Myboard'),
                openOn: 'right',
                width:screen.width,
            });
            panel.promise.then(result => {
                window.callbackBackKey = this.callbackBackKey;
                if (result.result === "close"){
                    this.slidePanelClose(result);
                }
            });
        },
        // 알림설정 정보
        getPushInfoFunc(){
            let param = {};
            this.ajaxGetAuth('/api/v1/push/info', param, this.getPushInfoFuncResult);
        },
        // 알림설정 정보 결과
        getPushInfoFuncResult(response){
            if (response.result.code == 0){
                this.bReplyAlarmYn = response.oMyInfo.oAlarm.bReplyAlarmYn;
                this.bNoticeAlarmYn = response.oMyInfo.oAlarm.bNoticeAlarmYn;
                this.bMessageAlarmYn = response.oMyInfo.oAlarm.bMessageAlarmYn;
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
        // 알림설정 변경
        setPushChangeFunc(){
            let formData = new FormData();
            formData.append('bReplyAlarmYn', (this.bReplyAlarmYn == true) ? 'Y' : 'N');
            formData.append('bNoticeAlarmYn', (this.bNoticeAlarmYn == true) ? 'Y' : 'N');
            formData.append('bMessageAlarmYn', (this.bMessageAlarmYn == true) ? 'Y' : 'N');

            this.ajaxPostAuth('/api/v1/push/change', formData);
        },
    }
}
</script>

<style scoped>
    .slidePanel-title {border-bottom:none}
    .li-bottom-line li { padding: 15px 0; }
    .li-bottom-line li a{color: #000;}
    .arrow {top: 21px}
    .mint-switch { position: absolute;right: 0; top: 12px;}

    .profile-area {flex: 1;display: flex;flex-direction: row;}
    .image-area {flex-basis: 75px;margin-right: 20px;    border-radius: 5px;background-repeat: no-repeat;background-position: center;}
    .nickname-area {flex: 1;}
    .nickname-area h5{font-size: 12px; color: #959595; font-weight: 300}
    .nickname-area h3{font-size: 18px; color: #000;font-weight: 600}
    .nickname-area h3 span{font-weight: 400;color: #959595;}
    .nickname-area span{font-size: 14px; color: #000;font-weight: 500}

</style>
